import { useContent } from '../data/ContentContext';
import { FeatureIcon } from '../components/icons';
import { AgentNetworkFlow } from '../components/AgentNetworkFlow';
import { AgentOrchestration } from '../components/AgentOrchestration';
import { Constellation } from '../components/Constellation';
import { QualityPuzzle } from '../components/QualityPuzzle';
import './featurePage.css';
import './SqmConsultantPage.css';

export function SqmConsultantPage() {
  const { sqmConsultantContent } = useContent();
  const { realExample } = sqmConsultantContent;
  const { specificAgent, agentCore } = realExample;

  return (
    <div className="page">
      {/* Hero */}
      <section className="sc-hero">
        <h1 className="sc-hero__title">Readiness Review Module</h1>
        <p className="sc-hero__summary">
          Our latest state of the intelligent Readiness Review function with AI.
          Connects disparate product data from design, manufacturing, and the
          field to proactively identify potential quality issues, accelerate
          root cause analysis, and provide actionable Go/No-Go recommendations.
        </p>
      </section>

      {/* Quality puzzle overview */}
      <QualityPuzzle className="sc-puzzle" />

      {/* Real Example - Specific Agent + Agent Core (side by side) */}
      <section className="feat-card">
        <h2 className="feat-card__title">
          <FeatureIcon name="target" /> Real Example
        </h2>

        <div className="sc-example sc-example--split">
          {/* Specific Agent */}
          <div className="sc-example__col">
            <h3 className="sc-example__title">Specific Agent</h3>
            <div className="sc-example__grid">
              <ul className="sc-example__list">
                {specificAgent.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="sc-example__media">
                <AgentOrchestration
                  title=""
                  subtitle=""
                  hubLabel="SQM Agent Core"
                  agents={['CPK', 'Yield', 'FATP Issue', 'GRR evaluation']}
                />
              </div>
            </div>
          </div>

          {/* Agent Core */}
          <div className="sc-example__col">
            <h3 className="sc-example__title">Agent Core</h3>
            <div className="sc-example__grid sc-example__grid--reverse">
              <div className="sc-example__media">
                <AgentNetworkFlow
                  question="do the RR"
                  answer="RR report ready"
                  agents={['CPK', 'Yield', 'FATP Issue', 'GRR']}
                  coreLabel="SQM Agent Core"
                />
              </div>
              <ul className="sc-example__list">
                {agentCore.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Agent Core Neural Network (collapsible) */}
      <details className="feat-card sc-collapse" open>
        <summary className="sc-collapse__summary">
          <span className="feat-card__title sc-collapse__title">
            <FeatureIcon name="grid" /> Agent Core Neural Network
          </span>
          <span className="sc-collapse__chevron" aria-hidden>
            ▾
          </span>
        </summary>
        <div className="sc-collapse__body">
          <p className="sc-collapse__hint">
            Each star is a key readiness-review capability. Select one to open
            its dedicated page.
          </p>
          <div className="sc-example__media sc-example__media--sky">
            <Constellation />
          </div>
        </div>
      </details>
    </div>
  );
}
